import Vue from "vue";
import VueRouter from "vue-router";
import Index from "../views/Index.vue";

Vue.use(VueRouter);

const routes = [{
  path: "/",
  name: "index",
  component: Index,
  redirect: "/home",
  children: [{
      path: "/home",
      name: "home",

      component: () => import("../views/Twolevelrouting/Home.vue")
    },
    // 论坛
    {
      path: "/forum",
      name: "forum",

      component: () => import("../views/Twolevelrouting/Forum.vue")
    },
    // 二手车源
    {
      path: "/usedcarsource",
      name: "usedcarsource",
      component: () => import("../views/Twolevelrouting/Usedcarsource.vue")
    },
    // 车源详情
    {
      path: "/usedtemplate",
      name: "usedtemplate",
      component: () => import("../views/Twolevelrouting/Usedtemplate.vue")
    },
    // 检车必看
    {
      path: "/inspectionmust",
      name: "inspectionmust ",

      component: () => import("../views/Twolevelrouting/Inspectionmust .vue")
    },
    // 加入我们
    {
      path: "/joinus",
      name: "joinus",

      component: () => import("../views/Twolevelrouting/Joinus.vue")
    },
    // 关于我们
    {
      path: "/aboutus",
      name: "aboutus",

      component: () => import("../views/Twolevelrouting/Aboutus.vue")
    }
  ]
}];

const router = new VueRouter({
  routes
});

export default router;